<template>
  <div>
    <span v-if="authLoading">loading-state</span>
    <span v-if="subscribed">Текущий план</span>
    <router-link :to="`/payment/${this.planId}`" v-else>Выбрать план</router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PaymentAction',
  props: {
    planId: { type: String, required: true }
  },

  computed: {
    ...mapState(['authLoading', 'userAccount']),

    subscriptionId () {
      if (this.userAccount && this.userAccount.subscription) {
        return this.userAccount.subscription.planId
      }
      return null
    },
    subscribed () {
      if (this.planId && this.subscriptionId) {
        return this.planId === this.subscriptionId
      }
      return false
    }
  }
}
</script>
